import notice from "../../../utils/notice";
import {
  getMultipartParams,
  handleResponse,
} from "../../../crud/helpers/validate";
import { useContentsContext } from "./useContentsContext.hook";
import { CONTRIBUTING_FACTORS } from "../../../crud/helpers/routes";

export const useContribuitingFactors = () => {
  const { setContributingFactors } = useContentsContext();
  const getFactors = async () => {
    let page = 1;
    let query = "";
    try {
      const res = await fetch(
        `${CONTRIBUTING_FACTORS}?page=${page}&search_query=${query}`,
        getMultipartParams("GET")
      );
      const json = await handleResponse(res);
      const data = json.map(({ id, name }) => ({ text: name, value: id }));
      setContributingFactors(data);
    } catch (err) {
      notice("Error on loading content ");
      console.error(err?.errors ?? err);
    }
  };

  return { getFactors };
};
